function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint0_linear)",
  d: "M20.8057 5.74347C17.0681 0.603892 9.8762 -0.535714 4.74079 3.1946C-0.39882 6.93116 -1.53415 14.1189 2.19613 19.2532C5.93164 24.3959 13.1236 25.5334 18.259 21.8021C23.3995 18.0666 24.5329 10.8789 20.8057 5.74347Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint1_linear)",
  d: "M19.5375 6.66536C16.308 2.22729 10.0967 1.2414 5.66287 4.46359C1.2248 7.69205 0.243127 13.8991 3.46419 18.333C6.69164 22.7742 12.9028 23.7569 17.3378 20.5358C21.7759 17.3073 22.7555 11.0993 19.5375 6.66536Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint2_linear)",
  d: "M13.0691 14.6521C13.067 14.6281 13.067 14.603 13.0648 14.5789C12.8139 12.2046 10.4407 8.61758 10.4407 8.61758V8.62281C10.2985 8.34679 10.0162 8.15967 9.68374 8.15967C9.35856 8.15967 9.08468 8.34679 8.93523 8.61758H8.93319C8.93319 8.61758 6.55788 12.2046 6.31004 14.5789C6.308 14.603 6.3048 14.6281 6.30276 14.6521C6.29651 14.7577 6.28809 14.8581 6.28809 14.9595C6.28809 16.834 7.8082 18.3584 9.68272 18.3584C11.5625 18.3584 13.0858 16.834 13.0858 14.9595C13.0879 14.8581 13.0858 14.7567 13.0691 14.6521Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint3_linear)",
  d: "M16.6938 12.0532C16.6918 12.0375 16.6906 12.0239 16.6876 12.0093C16.5391 10.5864 15.1141 8.42955 15.1141 8.42955V8.43478C15.0294 8.27063 14.8622 8.15771 14.6614 8.15771C14.4649 8.15771 14.2986 8.26958 14.2098 8.43162V8.42952C14.2098 8.42952 12.7869 10.5863 12.6373 12.0093C12.6353 12.0239 12.6353 12.0375 12.6353 12.0532C12.6248 12.1138 12.6206 12.1776 12.6206 12.2372C12.6206 13.3631 13.5364 14.2769 14.6604 14.2769C15.7864 14.2769 16.699 13.3631 16.699 12.2372C16.7011 12.1776 16.6958 12.1139 16.6938 12.0532Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint4_linear)",
  d: "M14.6624 8.15857C14.8621 8.15857 15.0304 8.27043 15.1151 8.43564V8.43041C15.1151 8.43041 16.5401 10.5872 16.6885 12.0102C16.6917 12.0248 16.6927 12.0384 16.6948 12.0541C16.6968 12.1147 16.702 12.1785 16.702 12.2381C16.702 13.364 15.7893 14.2778 14.6634 14.2778C13.5396 14.2778 12.6236 13.364 12.6236 12.2381C12.6236 12.1785 12.6278 12.1147 12.6383 12.0541C12.6383 12.0384 12.6383 12.0248 12.6403 12.0102C12.7898 10.5873 14.2128 8.43041 14.2128 8.43041V8.43251C14.2996 8.27043 14.4658 8.15857 14.6624 8.15857ZM14.6625 7.07129C14.1073 7.07129 13.596 7.35774 13.3107 7.82822L13.3023 7.8324C13.1434 8.07287 11.7268 10.2548 11.5584 11.8972C11.5564 11.9192 11.549 11.9464 11.548 11.9798C11.5395 12.0467 11.5344 12.144 11.5344 12.2381C11.5344 13.9611 12.9385 15.3662 14.6614 15.3662C16.3865 15.3662 17.7895 13.9611 17.7895 12.2381C17.7895 12.1482 17.7832 12.052 17.7727 11.9568L17.7685 11.8899C17.6002 10.2569 16.1856 8.0781 16.0205 7.8324C15.7382 7.35774 15.2228 7.07129 14.6625 7.07129Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint5_linear)",
  d: "M42.9885 12.3708C43.0038 12.1932 43.0038 12.0066 42.9885 11.8238C42.9578 11.4148 42.8568 11.0148 42.6804 10.7003L38.3105 3.15437C38.2849 3.08408 38.2351 3.02401 38.1916 2.96266L37.2777 1.38803C36.8573 0.623728 35.7427 0 34.8775 0H33.0089H25.9921H24.1222C23.2594 0 22.1437 0.623728 21.7231 1.38803L20.8106 2.96266C20.7659 3.0253 20.716 3.08537 20.6917 3.15437L16.3205 10.7003C16.1493 11.0071 16.0483 11.3969 16.0125 11.7983C15.9959 11.9976 15.9959 12.1996 16.0125 12.4028C16.047 12.8041 16.148 13.1888 16.3205 13.4956L17.499 15.5227L20.6904 21.0518C20.7351 21.1566 20.7889 21.2537 20.8656 21.3394C20.8732 21.3522 20.8873 21.3598 20.895 21.3739L21.7296 22.8067C22.1488 23.5761 23.2595 24.2049 24.135 24.2049H26.019H32.9821H34.8661C35.7416 24.2049 36.8548 23.5761 37.2727 22.8067L38.1074 21.3739C38.1163 21.3586 38.1278 21.3509 38.138 21.3394C38.2147 21.255 38.2684 21.1566 38.3118 21.0518L41.5033 15.5227L42.6817 13.4956C42.8568 13.1825 42.9578 12.785 42.9885 12.3708Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint6_linear)",
  d: "M40.9921 12.3326C41.0061 12.1818 41.0061 12.0221 40.9921 11.8674C40.9665 11.5172 40.8809 11.176 40.7288 10.9088L37.0069 4.47861C36.9852 4.41983 36.9417 4.36741 36.9047 4.31756L36.1263 2.9717C35.7684 2.32113 34.8175 1.79199 34.0813 1.79199H32.4888H26.5085H24.9147C24.1785 1.79199 23.2289 2.32113 22.871 2.9717L22.0939 4.31756C22.0556 4.36741 22.0121 4.41979 21.9917 4.47861L18.2672 10.9088C18.1229 11.1708 18.0346 11.5031 18.0065 11.8444C17.9912 12.0144 17.9912 12.1869 18.0065 12.3607C18.0346 12.7007 18.1229 13.0292 18.2672 13.2899L19.2705 15.0179L21.9903 19.7316C22.03 19.8211 22.0747 19.9016 22.1399 19.9757C22.1463 19.9846 22.1578 19.991 22.1655 20.0025L22.8762 21.2244C23.2341 21.8788 24.1799 22.4143 24.9263 22.4143H26.5303H32.4633H34.0674C34.8138 22.4143 35.7621 21.8788 36.1175 21.2244L36.8294 20.0025C36.837 19.9897 36.8473 19.9833 36.855 19.9757C36.9202 19.9003 36.9649 19.8211 37.0045 19.7316L39.7231 15.0179L40.7251 13.2899C40.8809 13.0228 40.9665 12.6842 40.9921 12.3326Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint7_linear)",
  d: "M34.4698 10.6887L30.918 10.6862L28.0793 10.6836H24.5287H24.5261C23.7439 10.6836 23.1086 11.3175 23.1086 12.0997C23.1086 12.8871 23.7426 13.5184 24.5261 13.5184L28.0793 13.521L30.918 13.5236H34.4698C35.2533 13.5236 35.8899 12.8896 35.8899 12.1074C35.8911 11.3201 35.2546 10.6887 34.4698 10.6887Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -1.8517,
  x2: 56.4251,
  y1: 31.9981,
  x1: 24.9332,
  id: "paint0_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 1.37251,
  x2: -24.3672,
  y1: -49.0726,
  x1: 21.3705,
  id: "paint1_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 22.5639,
  x2: -9.20023,
  y1: 11.6242,
  x1: 3.00826,
  id: "paint2_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 24.0311,
  x2: -6.24544,
  y1: 13.0906,
  x1: 5.96372,
  id: "paint3_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -20.54,
  x2: -26.6757,
  y1: -55.3668,
  x1: 28.8579,
  id: "paint4_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 2.09663,
  x2: 58.9473,
  y1: 40.7033,
  x1: 38.082,
  id: "paint5_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 14.9114,
  x2: 46.9625,
  y1: 47.8077,
  x1: 29.1893,
  id: "paint6_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 20.7278,
  x2: 7.68716,
  y1: 10.9569,
  x1: 7.81559,
  id: "paint7_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})));

var SvgIconRemoveLiquidity = function SvgIconRemoveLiquidity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 43 25",
    height: 25,
    width: 43,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRemoveLiquidity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Remove_Liquidity.426032d8.svg";
export { ForwardRef as ReactComponent };